import Vue from 'vue';
import Dialog from '@/components/vueDialog.vue';

const DialogConstructor = Vue.extend(Dialog);

let instance;

const initInstance = () => {
  instance = new DialogConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};

const DialogPlugin = (options = {}) => {
  if (!instance) {
    initInstance();
  }
  
  // 合并选项
  Object.assign(instance, {
    ...options,
    visible: true
  });
  
  return new Promise((resolve, reject) => {
    instance.$once('confirm', () => {
      resolve();
    });
    instance.$once('cancel', () => {
      reject(new Error('cancel'));
    });
    instance.$once('close', () => {
      reject(new Error('close'));
    });
  });
};

DialogPlugin.alert = (message, title = '提示') => {
  return DialogPlugin({
    title,
    message,
    showCancelButton: false
  });
};

DialogPlugin.confirm = (message, title = '确认') => {
  return DialogPlugin({
    title,
    message
  });
};

DialogPlugin.close = () => {
  if (instance) {
    instance.visible = false;
  }
};

const install = (Vue) => {
  Vue.prototype.$DialogVue = DialogPlugin;
};

export default install;